import * as THREE from 'three'
import Experience from '../Experience.js'

import { RectAreaLightHelper } from 'three/addons/helpers/RectAreaLightHelper.js';


export default class LightBox
{
    constructor(x, y, z, hue, light, uniform)
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.hue = hue
        if(uniform) {
            this.saturation = 75
        } else {
            this.saturation = Math.floor($fx.rand() * 100)
        }
        this.light = light

        this.lights = new THREE.Group();
        this.createCube(x, y, z);
    }

    update(x) {
        this.hue += x;
        this.lights.traverse(( child ) => {
            if ( child.isRectAreaLight ) {
                child.color = new THREE.Color(`hsl(${this.hue}, ${this.saturation}%, ${this.light}%)`);
            }
        });
    }

    createLight(px, py, pz, rx, ry, rz) {
        const light = new THREE.RectAreaLight( new THREE.Color(`hsl(${this.hue}, ${this.saturation}%, 75%)`), 1, 1, 1 );
        light.position.set( px, py, pz );
        light.rotation.set( rx, ry, rz );
        this.lights.add( light )
        this.lights.add( new RectAreaLightHelper( light ) )
    }

    createCube(x, y, z)
    {
        this.createLight( 0, 0, -0.5, 0, 0, 0 )
        this.createLight( 0, 0, 0.5, 0, Math.PI, 0 )
        this.createLight( -0.5, 0, 0, 0, Math.PI * 0.5, 0 )
        this.createLight( 0.5, 0, 0, 0, -Math.PI * 0.5, 0 ) 
        this.createLight( 0, 0.5, 0, Math.PI * 0.5, 0, 0 )
        this.createLight( 0, -0.5, 0, -Math.PI * 0.5, 0, 0 )

        this.lights.position.set(x, y, z)
    }

    getSceneObject() {
        return this.lights;
    }
}